import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./piracy.css";

function Piracy() {
  const [sortedData, setSortedData] = useState([]);
  const [loading, setLoading] = useState(true);




  useEffect(() => {
    axios.get(`${INVENTORY_API_BASE_URL}/get-duplicate-barcode-users`)
      .then((response) => {
        const data = response.data;

        const sorted = Object.entries(data)
          .filter(([_, details]) => details.total_email_ids >= 4)
          .sort((a, b) => b[1].total_email_ids - a[1].total_email_ids);

        setSortedData(sorted);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="piracy-container">
      <h2 style={{ textAlign: "center" }}>Duplicate Barcode Users</h2>
      {sortedData.length === 0 ? (
        <p>No duplicate barcodes found.</p>
      ) : (
        sortedData.map(([barcode, details]) => (
          <div key={barcode} style={{ marginBottom: "40px" }}>
            <h3>Barcode : {barcode}</h3>
            <div style={{ overflowX: "auto", width: "100%" }}>
              <table
                style={{
                  minWidth: "1500px",
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "14px",
                  whiteSpace: "nowrap",
                }}
              >
                <thead>
                  <tr style={{ backgroundColor: "#f2f2f2" }}>
                    {[
                      "SR.NO",
                      "Full Name",
                      "Email ID",
                      "Mobile Number",
                      "Timestamp",
                      "Pincode",
                      "City",
                      "Online Mode",
                      "Order Number",
                      "Seller",
                      "Bookshop",
                      "Address",
                      "Coins",
                    ].map((heading, index) => (
                      <th
                        key={index}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          background: "#f9f9f9",
                        }}
                      >
                        {heading}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {details.user_details.map((user, index) => (
                    <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.full_name}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.email_id}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.mobile_number}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {new Date(user.ts).toISOString().split("T")[0]}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.pincode || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.city || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.OnlineMode || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.OrderNum || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.OnlineSeller || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.BookShop || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.BookshopAddress || "-"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          textAlign: "center",
                        }}
                      >
                        {user.book_details.coins || "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default Piracy;
